import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SlideTextDirective } from '@shared/directives/sliding-text-animation/sliding-text-animation.directive';
import { isArray } from 'lodash-es';
import { twMerge } from 'tailwind-merge';

@Component({
  selector: 'pdf-body-block',
  imports: [NgClass, NgStyle, SlideTextDirective],
  templateUrl: './body-block.component.html',
  styleUrl: './body-block.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BodyBlockComponent {
  @Input() type: 'long-body' | 'short-body' | 'small-body' = 'short-body';
  @Input() class: string = '';
  @Input() customClasses: string = '';
  @Input() style: Record<string, any> | null = null;
  @Input() label: string = '';
  @Input() value: string | string[] = '';
  @Input() labelClass: string = '';
  @Input() valueClass: string = '';
  @Input() animateText: boolean = false;
  @Input() textValueClass: string = '';

  @Output() clickValue: EventEmitter<any> = new EventEmitter<any>();
  protected readonly isArray: typeof isArray = isArray;

  get mergedLabelClass(): string {
    return twMerge('truncate w-full', this.labelClass);
  }

  get mergedValueClass(): string {
    return twMerge('font-medium flex w-full', 'whitespace-pre-line', this.valueClass);
  }

  get mergedClass(): string {
    return twMerge(
      'flex flex-row items-center w-full',
      this.type === 'short-body' ? 'body-short' : this.type === 'long-body' ? 'body-long' : 'body-small',
      this.class,
      this.customClasses
    );
  }

  onValueClick() {
    this.clickValue.emit();
  }
}
